import { render, staticRenderFns } from "./vue-pagination.vue?vue&type=template&id=2936dc9e&scoped=true"
import script from "./vue-pagination.vue?vue&type=script&lang=js"
export * from "./vue-pagination.vue?vue&type=script&lang=js"
import style0 from "./vue-pagination.vue?vue&type=style&index=0&id=2936dc9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936dc9e",
  null
  
)

export default component.exports